import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
    query BrandPage($id: ID!,  $masterLimit: Int) {
      BrandPage: Brand(id: $id) {
        ...brandDetail
        ...brandBigDetail
        ...brandArtworks
        ...brandFilms
        ...brandCompanies
        ...brandProducts
      }
    }
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.filmDetail}
    ${fragments.filmMasters}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmHost}
    ${fragments.filmMasterPosterFrames}
    ${fragments.filmFiles}
    ${fragments.filmFileDetail}
    ${fragments.brandFilms}
    ${fragments.brandDetail}
    ${fragments.brandBigDetail}
    ${fragments.brandArtworks}
    ${fragments.brandCompanies}
    ${fragments.brandProducts}
    ${fragments.productDetail}
    ${fragments.productArtworks}
    ${fragments.productCategory}
    ${fragments.productCategoryTree}
    ${fragments.companyArtworks}
    ${fragments.companyNames}
    ${fragments.companyNameDetail}
    ${fragments.companyDetail}
    ${fragments.relationshipTypeDetail}
    ${fragments.filmBigAwards}
    ${fragments.awardPrizeArtworks}
    ${fragments.awardPrizeDetail}
    ${fragments.awardAncestor}
  `
